import React from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { Grid, Dialog, Button, SubmitButton, DatePicker, CreatableSelectSM } from "../../../../../";
import { makeStyles } from "@material-ui/styles";
import { TextField } from "formik-material-ui";
import { Debug } from "../../../../../Molecules/Forms/Debug";
import { Typography } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogCampusSingleDeleteVenue = function DialogCampusSingleDeleteVenue(props) {
  var initialValues = props.data || {
    name: ""
  };
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: props.translation ? props.translation.title || "Delete Venue" : "Delete Venue",
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.onClose();
    },
    render: function render(_ref) {
      var isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, props.translation ? props.translation.text || "Are you sure that you want to delete this venue?" : "Are you sure that you want to delete this venue?"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.translation ? props.translation.buttons ? props.translation.buttons.submit || "Delete" : "Delete" : "Delete")));
    }
  }));
};

export { DialogCampusSingleDeleteVenue };